import { render, staticRenderFns } from "./perInfo.vue?vue&type=template&id=6b0a9977&scoped=true&"
import script from "./perInfo.vue?vue&type=script&lang=js&"
export * from "./perInfo.vue?vue&type=script&lang=js&"
import style0 from "./perInfo.vue?vue&type=style&index=0&id=6b0a9977&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a9977",
  null
  
)

export default component.exports